"use strict";
/**
 * Created on 03 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var RealImpactValueConverter_1 = require("../../../impact/conversions/RealImpactValueConverter");

var SelloutProductPriceImpact_1 = require("../../model/sellout/SelloutProductPriceImpact");

var SelloutProductPriceImpactConverter_1 = require("./SelloutProductPriceImpactConverter");
/**
 * Implementation of {@link SelloutProductPriceImpactConverter}.
 *
 * @author JMe
 */


var SelloutProductPriceImpactConverterImpl =
/*#__PURE__*/
function (_SelloutProductPriceI) {
  _inherits(SelloutProductPriceImpactConverterImpl, _SelloutProductPriceI);

  function SelloutProductPriceImpactConverterImpl(realImpactConverter) {
    var _this;

    _classCallCheck(this, SelloutProductPriceImpactConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutProductPriceImpactConverterImpl).call(this));
    _this.realImpactConverter = realImpactConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutProductPriceImpactConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        productId: conversions.toDocumentReferenceId(source.productId),
        realImpact: source.realImpact ? this.realImpactConverter.toDocument(source.realImpact, conversions) : null
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutProductPriceImpact_1.SelloutProductPriceImpact(SelloutProductPriceImpact_1.SelloutProductPriceImpact.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), conversions.asObjectOpt(source, 'realImpact', function (doc) {
        return _this2.realImpactConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SelloutProductPriceImpactConverterImpl;
}(SelloutProductPriceImpactConverter_1.SelloutProductPriceImpactConverter);

SelloutProductPriceImpactConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RealImpactValueConverter_1.RealImpactValueConverter])], SelloutProductPriceImpactConverterImpl);
exports.SelloutProductPriceImpactConverterImpl = SelloutProductPriceImpactConverterImpl;